import { Typography } from "@mui/material";
import imgQuartermile from './assets/quarterMile.jpg';
import imgCentralCocoanut from './assets/centralCoconutHistoric.jpg';
import videoNeighborhood from './assets/neighborhoodvideo.mov';

import './purpleairWebpage.css';

const PageHistory = () => {

    return (<>
        <div className='pageContainer' >
            <div className='pageInnerContainer'> 


                <Typography variant="h5" gutterBottom>1950 through 2014 - Safe Coexistence</Typography>
                <p>Even though the property was zoned as industrial, for many decades the site operated as an automobile junk / metal scrap yard and without detrimentally impacting
                    the surrounding residental properties. </p>
                <p>
                    In fact the surrounding community thrived.
                </p>
                <img src={imgQuartermile} style={{ width: '100%' }} alt='map of a quarter mile around U.S. Recycling' />
                Within a 1/4 mile of the facility, there are:
                <ul>
                    <li style={{ paddingBottom: "10px" }}>over 200 homes,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>2 city parks (Mary Dean & Pioneer),
                    </li>
                    <li style={{ paddingBottom: "10px" }}>an historic district including the headquarters for the Sarasota Historic Society,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>an assisted living facility,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>a memory care facility,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>television studios,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>a heads-start child daycare center,
                    </li>
                    <li style={{ paddingBottom: "10px" }}> a memory care facility,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>restaurants,
                    </li>
                    <li style={{ paddingBottom: "10px" }}>and numerous other businesses.
                    </li>
                </ul>

                <p>The Central Cocoanut neighborhood has flourished over the decades as shown in this promotional piece from 2007:
                </p>
                <img src={imgCentralCocoanut} style={{ width: '100%' }} alt='promotional literature for Central Cocoanut' />
                <Typography variant="h5" gutterBottom style={{marginTop:'10px'}}>2015 through 2021 - Business Transitioned</Typography>    
                <p>
                    Starting in 2015, U.S. Recycling started to move away from operating as a vehicle towing yard towards a facility that recycled concrete and other scrap materials.</p>
                    <p>
                    Ultimately it started to crush concrete and was issued a Nonmetallic Mineral Processing Plant (Crusher) Air General Permit on February 12, 2021. 
                    This new property use, while technically legal for the city's industrial zoning, was and continues 
                    to be hazardous to the community by emitting concrete dust.
                </p>
                <Typography variant="h5" gutterBottom>2021 through 2024 - Harmful Operations</Typography>
                  <Typography variant="h6" gutterBottom style={{marginTop:'10px'}}>Significant Government Resources Expended</Typography>
                <p>The City of Sarasota spent over $400,000 to create a smooth roadway around U.S. Recycling to avoid jossling
                     the concrete hauled into and concrete dust hauled out of the facility.</p>
                <p>Since 2022, Sarasota County has performed over 20 inspections, only occasionally finding conditions egregious
                     enough to issue citations. (see other page on why regulating concrete crushing is so difficult).</p>
            
                <Typography variant="h6" gutterBottom style={{marginTop:'10px'}}>Residents Take Action</Typography>
                <p>Even with outcry and advocacy by the neighbors (both residents and other local business) as well as the significant govenment resources, the cement crushing continues.</p>
                <p>Towards the end of 2024, there was a glimmer of hope as U.S. Recycling surrendered its crushing permit and the was talk of a potential sale of the facility. 
                    However, in 2025 a relocatable crushing unit, owned and operated by Junk Removal.com, Inc, was brought in
                     and the crushing continued. 
                </p>    
                <Typography variant="h5" gutterBottom style={{marginTop:'10px'}}>2025 - Harmful Operations Continue</Typography>
                <p>Operating concrete crushing in such close proximity to a residential community is inherently unhealthy. The only safe solution is discontinuing the crushing facility and finding an alternative use for the site.</p>
                <video width="100%" height="360" controls loop>
                    <source src={videoNeighborhood} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

        </div>
    </>);
}

export default PageHistory;